<template>
    <div class="vjs-menu-title">Info</div>
    <div id="AboutMenu" class="vjs-menu-text Menu">
        <div id="TextAboutContent">Universal Empreinte Player-UEP version 4.0<br> <b v-if="displayHref"><a id="href_empreinte"
                    target="_blank" rel="noreferrer" href="//www.empreinte.com">www.empreinte.com</a></b> </div>
    </div>
</template>

<script >
import { defineComponent } from 'vue';


export default defineComponent({

    name: 'InfoSection',
    data(){
        return{
            displayHref:true,
        }
    },
    created(){
        this.displayHref =  window.process.env.CLIENT_NAME!=='unesco'
    }
})
</script>
<style>
#href_empreinte {
    color: var(--vm-color-three);
    font-weight: 600;
    margin-top: 10px;
    display: inline-block;
    text-decoration: none;
}
</style>